import React, { useState, useEffect } from "react";
import Checkbox from "rc-checkbox";
import "rc-checkbox/assets/index.css";
import Navbar from "../components/TopNav";
import Footer from "../components/Footer";
import Countdown from "react-countdown";
import { toast } from "react-toastify";
import monos from "../images/buy/mons.svg";
import { allowance, approveTokens, getTokenBalance } from "../web3Helper";
import { checkIsWalletConnected, checkNetwork } from "../web3Utils";
import { duration, getNetworkName } from "../utils";
import { StakingService } from "../services/stakingServices";
import { FormattedDate, FormattedNumber, FormattedTime } from "react-intl";
import Swal from "sweetalert2";
import { NftStakingService } from "../services/NftStakingService";
import { NftTokenService } from "../services/NftTokenService";
import InfiniteScroll from "react-infinite-scroll-component";

const tDate = new Date("01 01 2022");
const utcDate = tDate.toUTCString();
const Stacking = () => {
  const [isWalletConnected, setIsWalletConnected] = useState(false);
  const [isCorrectNetwork, setIsCorrectNetwork] = useState(false);
  const [approvalAmount, setApprovalAmount] = useState(0);
  const [isApprovalInProgress, setIsApprovalInProgress] = useState(false);
  const [isStakeInProgress, setIsStakeInProgress] = useState(false);
  const [isUnStakeInProgress, setIsUnStakeInProgress] = useState(false);
  const [isClaimInProgress, setIsClaimInProgress] = useState(false);
  const [hasAgreedToTerms, setHasAgreedToTerms] = useState(false);
  const [tokenBalance, setTokenBalance] = useState(0);

  const [type, setType] = useState("nft");
  const [isInputToken, setInputToken] = useState(false);
  const [isInputDays, setInputDays] = useState(false);
  const [customTokens, setCustomTokens] = useState(0);
  const [customDays, setCustomDays] = useState(0);
  const [stakeObj, setStakeObj] = useState(null);
  const [estimate, setEstimate] = useState({
    nextRewardTime: 0,
    rewardCount: 0,
    ruleName: "",
  });
  const [stakeInfo, setStakeInfo] = useState({
    startTime: 0,
    amount: 0,
    periodInDays: 0,
  });

  const [tokens, setTokens] = useState([
    { total: 350, status: false },
    { total: 1000, status: false },
    { total: 1500, status: false },
    { total: 2500, status: false },
    { total: 3500, status: false },
  ]);

  const [days, setDays] = useState([
    { days: 60, status: false },
    { days: 90, status: false },
    { days: 120, status: false },
    { days: 150, status: false },
    { days: 200, status: false },
  ]);
  const rewardArray = [
    {
      mons: "350 $MONS",
      days: "60 Days",
      reward: "2 Monster Feeds Every Month",
      win: "Participation in",
      prize: "Potion Lottery",
    },
    {
      mons: "1000 $MONS",
      days: "90 Days",
      reward: "1 Potion Every Month",
      win: "Participation in",
      prize: "Coin Box Lottery",
    },
    {
      mons: "1500 $MONS",
      days: "120 Days",
      reward: "1 Coin Box Every Month",
      win: "Participation in",
      prize: "Monster Cave Lottery",
    },
    {
      mons: "2500 $MONS",
      days: "150 Days",
      reward: "1 Cave Every Month",
      win: "Participation in",
      prize: "Monster Lottery",
    },
    {
      mons: "3500 $MONS",
      days: "200 Days",
      reward: "1 Monster Every Month",
      win: "Participation in",
      prize: "Aloha Island Lottery",
    },
  ];

  const [initialising, setInitialising] = useState(false);
  const [hasAgreedToTermsForNftStaking, setHasAgreedToTermsForNftStaking] =
    useState(false);
  const [isNftBatchStakeInProgress, setIsNftBatchStakeInProgress] =
    useState(false);
  const [isNftUnStakeInProgress, setIsNftUnStakeInProgress] = useState({});
  const [isNftStakingClaimInProgress, setIsNftStakingClaimInProgress] =
    useState({});
  const [isNftApprovalInProgress, setIsNftApprovalInProgress] = useState(false);
  const [needsApproval, setNeedsApproval] = useState(false);
  const [nftBalance, setNftBalance] = useState(0);
  const [userStakeInfo, setUserStakeInfo] = useState(null);
  const [nftStakeObj, setNftStakeObj] = useState(null);
  const [daysForNftStaking, setDaysForNftStaking] = useState([
    { days: 30, status: false },
    { days: 60, status: false },
  ]);
  const [nftList, setNftList] = useState([]);

  const [stakedNftList, setStakedNftList] = useState([]);

  const setStatus = (focusType, value) => {
    if (focusType === "box-token") {
      setTokens(
        tokens.map((tok) =>
          tok.total === value
            ? { ...tok, status: true }
            : { ...tok, status: false }
        )
      );
      setInputToken(false);
    } else if (focusType === "input-token") {
      setTokens(tokens.map((tok) => tok && { ...tok, status: false }));
      setInputToken(true);
    } else if (focusType === "input-days") {
      setDays(days.map((tok) => tok && { ...tok, status: false }));
      setInputDays(true);
    } else {
      setDays(
        days.map((day) =>
          day.days === value
            ? { ...day, status: true }
            : { ...day, status: false }
        )
      );
      setInputDays(false);
    }
  };

  useEffect(() => {
    checkIsWalletConnected().then((isConnected) =>
      setIsWalletConnected(isConnected)
    );
    checkNetwork().then((isNetworkId) => setIsCorrectNetwork(isNetworkId));
    init();
    initNftStaking();
  }, []);

  const init = () => {
    const stakingService = new StakingService();
    stakingService.estimate().then(setEstimate);

    stakingService.getStakeInfo().then(setStakeInfo);

    getTokenBalance({}).then(setTokenBalance);
  };

  const handleApproval = async () => {
    if (!isWalletConnected) return toast.error("Please, Connect your Wallet.");
    if (!isCorrectNetwork) return toast.error("Incorrect Network.");
    const stakingService = new StakingService();

    setIsApprovalInProgress(true);
    try {
      await approveTokens({
        value: 1000000,
        spenderContractType: stakingService.contractType,
      });
      setIsApprovalInProgress(false);
      setApprovalAmount(0);
    } catch (err) {
      setIsApprovalInProgress(false);
      setApprovalAmount(0);
      setStakeObj(null);
    }
  };

  const handleStakeTokens = async () => {
    if (!isWalletConnected) return toast.error("Please, Connect your Wallet.");
    if (!isCorrectNetwork) return toast.error("Incorrect Network.");

    const stakingService = new StakingService();
    setIsStakeInProgress(true);

    stakingService
      .stake(stakeObj)
      .then(() => {
        setStakeObj(null);
        setIsStakeInProgress(false);
        toast.success("Tokens Staked Successfully!");
        init();
      })
      .catch((err) => {
        setStakeObj(null);
        setIsStakeInProgress(false);
        toast.error(err);
      });
  };

  const handleUnStakeTokens = async () => {
    if (!isWalletConnected) return toast.error("Please, Connect your Wallet.");
    if (!isCorrectNetwork) return toast.error("Incorrect Network.");

    let processStaking = true;
    if (
      new Date() <
      new Date(
        (stakeInfo.startTime + duration.days(stakeInfo.periodInDays)) * 1000
      )
    ) {
      const result = await Swal.fire({
        title: "Warning!",
        text: "Unlocking staked tokens before their staking period will result in a fine of 10%. Are you sure you want to unlock the tokens?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#FF5917",
        showConfirmButton: true,
      });
      if (result.isDismissed) processStaking = false;
    }

    if (processStaking) {
      const stakingService = new StakingService();
      setIsUnStakeInProgress(true);

      stakingService
        .unStake()
        .then(() => {
          setIsUnStakeInProgress(false);
          toast.success("Tokens Unlocked Successfully!");
          init();
        })
        .catch((err) => {
          setIsUnStakeInProgress(false);
          toast.error(err);
        });
    }
  };

  const handleClaim = async () => {
    if (!isWalletConnected) return toast.error("Please, Connect your Wallet.");
    if (!isCorrectNetwork) return toast.error("Incorrect Network.");
    if (!estimate.rewardCount) return toast.error("Rewards Unavailable.");

    const stakingService = new StakingService();
    setIsClaimInProgress(true);

    stakingService
      .claim()
      .then(() => {
        setIsClaimInProgress(false);
        toast.success("Rewards Claimed Successfully!");
        init();
      })
      .catch((err) => {
        setIsClaimInProgress(false);
        toast.error(err);
      });
  };

  const handleStakeInit = async () => {
    const stakingService = new StakingService();

    if (!isWalletConnected) return toast.error("Please, Connect your Wallet.");
    if (!isCorrectNetwork) return toast.error("Incorrect Network.");

    const selectedToken = tokens.find((token) => token.status);
    const amount = selectedToken ? selectedToken.total : customTokens;
    if (!amount) return toast.error("Amount is required!");

    if (isNaN(Number(amount))) return toast.error("Enter valid amount!");

    const selectedDays = days.find((day) => day.status);
    const periodInDays = selectedDays ? selectedDays.days : customDays;
    if (!periodInDays) return toast.error("Days is required!");

    if (isNaN(Number(periodInDays)))
      return toast.error("Enter valid number of days!");

    const allowanceAmount = await allowance({
      spenderContractType: stakingService.contractType,
    });

    if (allowanceAmount < amount) {
      setApprovalAmount(amount - allowanceAmount);
    }
    setStakeObj({
      amount,
      periodInDays,
    });
  };

  const initNftStaking = async () => {
    setInitialising(true);
    try {
      const nftTokenService = new NftTokenService();
      const nftStakingService = new NftStakingService();
      const nftBalance = await nftTokenService.balanceOf();
      const userInfo = await nftStakingService.getUserInfo();
      const nfts = await nftTokenService.getAll({});
      const stakedNftList = await nftStakingService.getAll({});

      setNftBalance(nftBalance);
      setUserStakeInfo(userInfo);
      setNftList(nfts);
      setStakedNftList(stakedNftList);
      setInitialising(false);
    } catch (err) {
      setInitialising(false);
    }
  };

  const handleSetDaysForNftStaking = (value) => {
    setDaysForNftStaking(
      daysForNftStaking.map((day) =>
        day.days === value
          ? { ...day, status: true }
          : { ...day, status: false }
      )
    );
  };

  const handleNftListCheckbox = (index, value) => {
    const clonedNftList = [...nftList];
    clonedNftList[index].isChecked = value;
    setNftList(clonedNftList);
  };

  const loadMoreNfts = async () => {
    const nftTokenService = new NftTokenService();
    const nfts = await nftTokenService.getAll({ skip: nftList.length });
    setNftList([...nftList, ...nfts]);
  };

  const loadMoreStakedNfts = async () => {
    const nftStakingService = new NftStakingService();
    const stakedNfts = await nftStakingService.getAll({
      skip: stakedNftList.length,
    });
    setStakedNftList([...stakedNftList, ...stakedNfts]);
  };

  const handleNftBatchStakeInit = async () => {
    if (!isWalletConnected) return toast.error("Please, Connect your Wallet.");
    if (!isCorrectNetwork) return toast.error("Incorrect Network.");

    const nftStakingService = new NftStakingService();
    const hasApproval = await nftStakingService.isApprovedForAll();
    setNeedsApproval(!hasApproval);

    const nftsToStake = nftList.filter((nft) => nft.isChecked);
    const selectedPeriod = daysForNftStaking.find((nft) => nft.status);

    if (!selectedPeriod || isNaN(Number(selectedPeriod.days)))
      return toast.error("Select period to Stake!");

    if (!nftsToStake.length) return toast.error("Select NFTs to Stake!");

    setNftStakeObj({
      nftList: nftsToStake,
      periodInDays: selectedPeriod.days,
    });
  };

  const handleNftApproval = async () => {
    if (!isWalletConnected) return toast.error("Please, Connect your Wallet.");
    if (!isCorrectNetwork) return toast.error("Incorrect Network.");

    const nftStakingService = new NftStakingService();
    try {
      setIsNftApprovalInProgress(true);
      await nftStakingService.setApprovalForAll();
      setNeedsApproval(false);
      setIsNftApprovalInProgress(false);
    } catch (err) {
      setIsNftApprovalInProgress(false);
    }
  };

  const handleNftBatchStake = async () => {
    if (!isWalletConnected) return toast.error("Please, Connect your Wallet.");
    if (!isCorrectNetwork) return toast.error("Incorrect Network.");

    const nftStakingService = new NftStakingService();
    setIsNftBatchStakeInProgress(true);

    nftStakingService
      .stakeBatch(nftStakeObj)
      .then(() => {
        setIsNftBatchStakeInProgress(false);
        setNftStakeObj(null);
        toast.success("NFTs Staked Successfully!");
        initNftStaking();
      })
      .catch((err) => {
        console.log("err", err);
        setNftStakeObj(null);
        setIsNftBatchStakeInProgress(false);
        toast.error(err);
      });
  };

  const handleNftUnStake = async (tokenId) => {
    if (!isWalletConnected) return toast.error("Please, Connect your Wallet.");
    if (!isCorrectNetwork) return toast.error("Incorrect Network.");

    const nftStakingService = new NftStakingService();

    setIsNftUnStakeInProgress({ [tokenId]: true });
    nftStakingService
      .unStake({ tokenId: tokenId })
      .then(() => {
        setIsNftUnStakeInProgress({ [tokenId]: false });
        toast.success("NFTs Unlocked Successfully!");
        setStakedNftList(
          stakedNftList.filter((nft) => nft.tokenId !== tokenId)
        );
      })
      .catch((err) => {
        setIsNftUnStakeInProgress({ [tokenId]: false });
        toast.error(err);
      });
  };

  const handleNftStakingClaim = async (tokenId) => {
    if (!isWalletConnected) return toast.error("Please, Connect your Wallet.");
    if (!isCorrectNetwork) return toast.error("Incorrect Network.");

    const nftStakingService = new NftStakingService();

    setIsNftStakingClaimInProgress({ [tokenId]: true });
    nftStakingService
      .claim({ tokenId: tokenId })
      .then(() => {
        setIsNftStakingClaimInProgress({ [tokenId]: false });
        toast.success("Rewards Claimed Successfully!");
        setStakedNftList(
          stakedNftList.map((nft) =>
            nft.tokenId === tokenId
              ? {
                  ...nft,
                  estimate: {
                    ...(nft.estimate
                      ? {
                          ...nft.estimate,
                          reward: 0,
                        }
                      : {}),
                  },
                }
              : nft
          )
        );
      })
      .catch((err) => {
        setIsNftStakingClaimInProgress({ [tokenId]: false });
        toast.error(err);
      });
  };

  const getStakeTimestampInMs = (timestamp, days = 0) =>
    (timestamp +
      days * (process.env.REACT_APP_ENV === "prod" ? 60 * 60 * 24 : 60)) *
    1000;

  return (
    <div className="row no-gutters staking">
      <Navbar />
      <div className="col-12 main">
        <button
          onClick={() => setType("token")}
          className={`${type === "token" ? "active-btn" : ""} top-btn btn`}
        >
          $MONS STAKING
        </button>
        <button
          onClick={() => setType("nft")}
          className={`${type === "nft" ? "active-btn" : ""} top-btn btn`}
        >
          NFT RENTING
        </button>
        {type === "token" && (
          <>
            {" "}
            <h6 className="mx-auto mb-3 pvp-launch">
              Considering the launch of PVP mode alpha version around the
              corner, staking of $MONS will be discontinued from 1st April,
              2023. However, users will be still able to claim rewards against
              the assets staked before 1st April, 2023.
            </h6>
            <p>
              Available Balance: <img src={monos} alt="" />{" "}
              <span>
                <FormattedNumber
                  maximumFractionDigits={0}
                  value={tokenBalance}
                />{" "}
                $MONS
              </span>
            </p>
            <div className="main-box staking">
              {/* <div className="box">
            <h5>STAKE $MONS</h5>
            <p>Please select your desired tier to stake your $MONS</p>
            <div className="btn-div">
              {tokens.map(token => (
                <button onClick={()=> setStatus('box-token', token.total)} className={`${token.status && 'active'} btn`}>
                  <FormattedNumber maximumFractionDigits={0} value={token.total} />
                </button>
              ))}
              <input 
                onFocus={()=>setStatus('input-token')}
                className={`${isInputToken && 'active'} form-control`}
                onChange={(e) => setCustomTokens(e.target.value)}
                placeholder="Other" 
              />
            </div>
            <div className="hr-div">
              <hr/>
              <span>For</span>
              <hr/>
            </div>
            <div className="btn-div">
              {days.map(day => (
                <button onClick={()=> setStatus('box-days', day.days)} className={`${day.status && 'active'} btn`}>{day.days} Days</button>
              ))}
              <input
               onFocus={()=>setStatus('input-days')} 
               className={`${isInputDays && 'active'} form-control`} 
               onChange={(e) => setCustomDays(e.target.value)}
               placeholder="Other" 
              />
            </div>
            <label>
            <Checkbox
              type="checkbox"
              onChange={(e) => setHasAgreedToTerms(e.target.checked)}
            />
            <div>
            I've read and understood the terms and conditions associated with 
            staking $MONS and that unlocking before lock days will be charged with 10% deduction fee. 
            </div>
          </label>
            {
              !isWalletConnected ?
                <button  className="btn buy" disabled={true}>
                  Connect your Wallet.
                </button>
              : !isCorrectNetwork ? 
                <button  className="btn buy" disabled={true}>
                  Switch to {getNetworkName(process.env.REACT_APP_MAIN_NETWORK_ID)} Network.
                </button> 
              : approvalAmount ? 
                <button onClick={handleApproval} className="btn upgrade" disabled={isApprovalInProgress}>
                  { isApprovalInProgress ? 'Please Wait!' : `Approve` }
                </button>
              : stakeObj ? 
                <button onClick={handleStakeTokens} className="btn upgrade" disabled={isStakeInProgress}>
                  { isStakeInProgress ? 'Please Wait!' : `Confirm Stake` }
                </button>
              :
                <button disabled={!hasAgreedToTerms} onClick={handleStakeInit} className="btn upgrade">
                  {
                    stakeInfo.startTime 
                    ? 'UPGRADE'
                    : 'STAKE'
                  }
                </button>
            }
          </div> */}
              <div className="box box-right">
                <div className="sub-right">
                  <h5>CURRENT STAKING</h5>
                  <h1>
                    <img src={monos} alt="" /> {stakeInfo.amount} $MONS
                  </h1>
                  <p>
                    You've currently staked{" "}
                    <span>{stakeInfo.amount} $MONS</span> locked for{" "}
                    <span>{stakeInfo.periodInDays} Days</span>!
                  </p>
                  <div className="mid-div">
                    <div>
                      <p>STAKE START DATE</p>
                    </div>
                    <div>
                      <p>
                        {stakeInfo.startTime ? (
                          <FormattedDate
                            timeZone="UTC"
                            hour12
                            dateStyle="medium"
                            value={stakeInfo.startTime * 1000}
                          />
                        ) : (
                          "-"
                        )}
                      </p>
                      <span>
                        {stakeInfo.startTime ? (
                          <FormattedDate
                            timeZone="UTC"
                            hour12
                            timeStyle="long"
                            value={stakeInfo.startTime * 1000}
                          />
                        ) : (
                          "-"
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="mid-div">
                    <div>
                      <p>STAKE END DATE</p>
                    </div>
                    <div>
                      <p>
                        {stakeInfo.startTime && stakeInfo.periodInDays ? (
                          <FormattedDate
                            timeZone="UTC"
                            hour12
                            dateStyle="medium"
                            value={
                              (stakeInfo.startTime +
                                duration.days(stakeInfo.periodInDays)) *
                              1000
                            }
                          />
                        ) : (
                          "-"
                        )}
                      </p>
                      <span>
                        {stakeInfo.startTime && stakeInfo.periodInDays ? (
                          <FormattedDate
                            timeZone="UTC"
                            hour12
                            timeStyle="long"
                            value={
                              (stakeInfo.startTime +
                                duration.days(stakeInfo.periodInDays)) *
                              1000
                            }
                          />
                        ) : (
                          "-"
                        )}
                      </span>
                    </div>
                  </div>
                  {!stakeInfo.startTime ? (
                    <button className="btn upgrade" disabled={true}>
                      NO TOKENS STAKED
                    </button>
                  ) : (
                    <button
                      className="btn upgrade"
                      disabled={!stakeInfo.startTime || isUnStakeInProgress}
                      onClick={handleUnStakeTokens}
                    >
                      {isUnStakeInProgress ? "Please Wait!" : `UNLOCK`}
                    </button>
                  )}
                </div>
                <div className="last-box">
                  <h5>
                    CLAIM REWARD [
                    {estimate.ruleName
                      ? estimate.ruleName.replace(/_/g, " ")
                      : "-"}
                    ]
                  </h5>
                  <div className="mid-div">
                    <div>
                      <p>REWARD CLAIM DATE</p>
                    </div>
                    <div>
                      <p>
                        {estimate.nextRewardTime ? (
                          <FormattedDate
                            timeZone="UTC"
                            hour12
                            dateStyle="medium"
                            value={estimate.nextRewardTime * 1000}
                          />
                        ) : (
                          "-"
                        )}
                      </p>
                      <span>
                        {estimate.nextRewardTime ? (
                          <FormattedDate
                            timeZone="UTC"
                            hour12
                            timeStyle="long"
                            value={estimate.nextRewardTime * 1000}
                          />
                        ) : (
                          "-"
                        )}
                      </span>
                    </div>
                  </div>
                  {estimate.nextRewardTime ? (
                    <>
                      {!estimate.rewardCount &&
                      new Date() < new Date(estimate.nextRewardTime * 1000) ? (
                        <button className="btn upgrade" disabled={true}>
                          <Countdown
                            date={new Date(estimate.nextRewardTime * 1000)}
                          />
                        </button>
                      ) : (
                        <button
                          className="btn upgrade"
                          onClick={handleClaim}
                          disabled={isClaimInProgress}
                        >
                          {isClaimInProgress ? "Please Wait!" : `CLAIM`}
                        </button>
                      )}
                    </>
                  ) : (
                    <button className="btn upgrade" disabled={true}>
                      CLAIM UNAVAILABLE
                    </button>
                  )}
                </div>
              </div>
            </div>
            <h1>Staking Rewards</h1>
            <div className="table-responsive last">
              <table className="table reward-info ">
                <thead>
                  <tr>
                    <th>
                      $MONS TOKENS <br /> <span>REQUIRED FOR STAKING</span>
                    </th>
                    <th>
                      COMMITMENT
                      <br /> <span>TIME PEROD</span>
                    </th>
                    <th>
                      REWARD <br />
                      <span>EVERY MONTH</span>
                    </th>
                    <th>
                      CHANCE TO WIN NFT LOTTERY <br />
                      <span>EVERY MONTH</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rewardArray.map((arr) => (
                    <tr>
                      <td>{arr.mons}</td>
                      <td>{arr.days}</td>
                      <td>{arr.reward}</td>
                      <td className="last">
                        {arr.win} <span>{arr.prize}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
        {type === "nft" && (
          <div>
            {/* <p className="w-75 m-auto">
          Presenting the NFT Renting, the opportunity for you to rent out your <b>Monsters Clan NFTs</b> to team Monsters Clan and earn rent of your NFTs in $MONS every month.
          Read <a href="https://bit.ly/3Jxo882" target="_blank" rel="noopener noreferrer" >NFT Renting</a> plan for more details.
        </p> */}

            <h6 className="mx-auto mb-3 pvp-launch">
              Considering the launch of PVP mode alpha version around the
              corner, staking of NFTs will be discontinued from 1st April, 2023.
              However, users will be still able to claim rewards against the
              assets staked before 1st April, 2023.
            </h6>

            <div className="main-box nft-staking">
              {/* <div className="box box-left py-3">
            <h5>RENT OUT YOUR NFTs</h5>
            <p>Please select your desired NFT you want to rent out</p>
            <div className="nft-list-1 mb-3" id="nft-list-1">
              {
                initialising ?
                  <div className="my-5">
                    Loading, please wait...
                  </div>
                : !isWalletConnected ?
                 <div className="my-5">
                    Please, connect your <b>wallet</b> to show your NFTs here!
                 </div>
                : !isCorrectNetwork ? 
                 <div className="my-5">
                    Switch to {getNetworkName(process.env.REACT_APP_MAIN_NETWORK_ID)} Network.
                 </div>
                : <InfiniteScroll
                    scrollableTarget="nft-list-1"
                    dataLength={nftList.length} //This is important field to render the next data
                    next={() => loadMoreNfts()}
                    hasMore={ nftList.length < nftBalance }
                    loader= {
                      <div className="card-1" tabIndex="0">
                        <div className="card-item">
                          Loading...
                        </div>
                      </div>
                    }
                  >
                    {
                      nftList.map((nft, index) => 
                        <div className="card-1" tabIndex="0">
                          <div className="card-item">
                            <img src={nft.image} />
                          </div>
                          <div className="card-item">
                            {nft.name} ({nft.tokenId})
                          </div>
                          <div className="card-item">
                           <label className="m-0 d-inline-block">
                            <Checkbox
                              type="checkbox"
                              checked={nft.isChecked}
                              onChange={(e) => handleNftListCheckbox( index, e.target.checked)}
                            />
                           </label>
                          </div>
                        </div>
                      )
                    }
                    {
                      !nftList.length &&
                      <div className="my-5">
                        No NFTs Available.
                      </div>
                    }
                  </InfiniteScroll>
              }
            </div>
            <div className="hr-div">
              <hr/>
              <span>For</span>
              <hr/>
            </div>
            <div className="btn-div text-left">
              {daysForNftStaking.map(day => (
                <button 
                  onClick={()=> handleSetDaysForNftStaking(day.days)}
                  className={`${day.status && 'active'} btn`}>
                    {day.days} Days
                </button>
              ))}
              <label>
                <Checkbox
                  type="checkbox"
                  onChange={(e) => setHasAgreedToTermsForNftStaking(e.target.checked)}
                />
                <div>
                  I've read and understood the terms and conditions associated with renting out NFTs. 
                </div>
              </label>
            </div>
            {
              !isWalletConnected ?
                <button  className="btn upgrade" disabled={true}>
                  Connect your Wallet.
                </button>
              : !isCorrectNetwork ? 
                <button  className="btn upgrade" disabled={true}>
                  Switch to {getNetworkName(process.env.REACT_APP_MAIN_NETWORK_ID)} Network.
                </button> 
              : needsApproval ? 
                <button onClick={handleNftApproval} className="btn upgrade" disabled={isNftApprovalInProgress}>
                  { isNftApprovalInProgress ? 'Please Wait!' : `Approve` }
                </button>
              : nftStakeObj ? 
                <button onClick={handleNftBatchStake} className="btn upgrade" disabled={isNftBatchStakeInProgress}>
                  { isNftBatchStakeInProgress ? 'Please Wait!' : `Confirm Stake` }
                </button>
              : <button 
                  onClick={handleNftBatchStakeInit}
                  disabled={!hasAgreedToTermsForNftStaking}
                  className="btn upgrade">
                  RENT
                </button>
            }
          </div> */}

              <div className="box box-right ml-3 py-3 mx-auto">
                <h5>CURRENT NFTs' RENT DETAILS</h5>
                {initialising ? (
                  <div className="my-5">Loading, please wait...</div>
                ) : !isWalletConnected ? (
                  <div className="my-5">
                    Please, connect your <b>wallet</b> to view your NFTs and
                    their rent earnings.
                  </div>
                ) : !isCorrectNetwork ? (
                  <div className="my-5">
                    Switch to{" "}
                    {getNetworkName(process.env.REACT_APP_MAIN_NETWORK_ID)}{" "}
                    Network.
                  </div>
                ) : (
                  <div className="nft-list-2" id="nft-list-2">
                    <div className="table-responsive last">
                      <InfiniteScroll
                        dataLength={stakedNftList.length} //This is important field to render the next data
                        next={() => loadMoreStakedNfts()}
                        scrollableTarget="nft-list-2"
                        hasMore={
                          userStakeInfo &&
                          stakedNftList.length < userStakeInfo.totalStakeAmount
                        }
                        loader={
                          <div className="w-100 nft-reward-row w-100 nft-reward-row rounded p-2">
                            Loading...
                          </div>
                        }
                      >
                        <table className="table nft-rewards mb-0">
                          <thead>
                            <th>NFT NAME</th>
                            <th>START DATE</th>
                            <th>END DATE</th>
                            <th>REWARD</th>
                            <th>ACTION</th>
                          </thead>

                          {stakedNftList.map((stakedNft) => (
                            <tr className="nft-reward-row" tabIndex="0">
                              <td>
                                <img src={stakedNft.image} />
                                <span className="ml-2">
                                  {stakedNft.name} ({stakedNft.tokenId})
                                </span>
                              </td>
                              <td>
                                <b>
                                  <FormattedDate
                                    timeZone="UTC"
                                    dateStyle="short"
                                    value={
                                      new Date(
                                        getStakeTimestampInMs(
                                          stakedNft.stakeInfo.startTime
                                        )
                                      )
                                    }
                                  />
                                </b>
                                <br />
                                <FormattedTime
                                  timeZone="UTC"
                                  hourCycle="h23"
                                  timeStyle="short"
                                  value={
                                    new Date(
                                      getStakeTimestampInMs(
                                        stakedNft.stakeInfo.startTime
                                      )
                                    )
                                  }
                                />{" "}
                                UTC
                              </td>
                              <td>
                                <b>
                                  <FormattedDate
                                    timeZone="UTC"
                                    dateStyle="short"
                                    value={
                                      new Date(
                                        getStakeTimestampInMs(
                                          stakedNft.stakeInfo.startTime,
                                          stakedNft.stakeInfo.periodInDays
                                        )
                                      )
                                    }
                                  />
                                </b>
                                <br />
                                <FormattedTime
                                  timeZone="UTC"
                                  hourCycle="h23"
                                  timeStyle="short"
                                  value={
                                    new Date(
                                      getStakeTimestampInMs(
                                        stakedNft.stakeInfo.startTime,
                                        stakedNft.stakeInfo.periodInDays
                                      )
                                    )
                                  }
                                />{" "}
                                UTC
                              </td>
                              <td>{stakedNft.estimate.reward} $MONS</td>
                              <td>
                                <button
                                  onClick={() =>
                                    handleNftUnStake(stakedNft.tokenId)
                                  }
                                  className="btn upgrade mb-1"
                                  disabled={
                                    isNftUnStakeInProgress[stakedNft.tokenId] ||
                                    new Date().getTime() <
                                      getStakeTimestampInMs(
                                        stakedNft.stakeInfo.startTime,
                                        stakedNft.stakeInfo.periodInDays
                                      )
                                  }
                                >
                                  {isNftUnStakeInProgress[stakedNft.tokenId]
                                    ? "PLEASE WAIT!"
                                    : `UNLOCK`}
                                </button>
                                <button
                                  onClick={() =>
                                    handleNftStakingClaim(stakedNft.tokenId)
                                  }
                                  className="btn upgrade mb-1 ml-2"
                                  disabled={
                                    isNftStakingClaimInProgress[
                                      stakedNft.tokenId
                                    ] || !stakedNft.estimate.reward
                                  }
                                >
                                  {isNftStakingClaimInProgress[
                                    stakedNft.tokenId
                                  ]
                                    ? "PLEASE WAIT!"
                                    : `CLAIM REWARD`}
                                </button>
                              </td>
                            </tr>
                          ))}
                        </table>
                        {!stakedNftList.length && (
                          <div className="my-5">No NFTs currently staked!</div>
                        )}
                      </InfiniteScroll>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Stacking;
